import _ from 'lodash';
import { getChangeContactPolicyCards } from './changeContactSelector';

export const getContactDetailsLabels = (state: {}) => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-customer-profile.contactDetailsLabel`,
    {},
  );
};

export const getContactDetailsPolicy = (state: {}, policyNumber: string) => {
  return (
    _.find(getChangeContactPolicyCards(state), [
      'policyNumber',
      policyNumber,
    ]) || {}
  );
};
